<template>
  <div class="main-popup-wrapper" v-if="checkDeposits(deposits)">
    <!--    <div class="left-container">-->
    <!--      <ul class="list-group">-->
    <!--        <li-->
    <!--          class="list-group-item list-item-animate"-->
    <!--          v-for="tab in secTabs"-->
    <!--          :key="tab.id"-->
    <!--          :class="{ active: selectedSecTab === tab.alias }"-->
    <!--          @click.stop="selectedSecTab = tab.alias"-->
    <!--        >-->
    <!--          <span>-->
    <!--            {{ tab.name.toUpperCase() }}-->
    <!--          </span>-->
    <!--        </li>-->
    <!--      </ul>-->
    <!--    </div>-->
    <!--    <div class="right-container">-->
    <div class="title-wrapper">
      <div class="title-date">
        <span class="title-date-class">{{
          reverseDate(dateFromCalendar)
        }}</span>
      </div>
      <div class="filter-options-wrapper">
        <div>
          <label class="filter-options-label">
            <input
              class="option-input radio"
              @click.stop="changeFilter($event)"
              type="radio"
              name="filters"
              id="regular"
              value="regular"
              checked
            />
            REGULAR
          </label>
          <label class="filter-options-label">
            <input
              class="option-input radio"
              @click.stop="changeFilter($event)"
              type="radio"
              name="filters"
              id="removed"
              value="removed"
            />
            REMOVED
          </label>
          <label class="filter-options-label">
            <input
              class="option-input radio"
              @click.stop="changeFilter($event)"
              type="radio"
              name="filters"
              id="cc-decline"
              value="cc-decline"
            />
            CC-DECLINE
          </label>
        </div>
      </div>
    </div>
    <div class="dep-table-wrapper">
      <DepositsTableSorted :deposits="deposits" :filter-option="filterOption" />
    </div>
    <div class="dep-table-wrapper">
      <DepositsStatsTables
        :deposits-stats="stats"
        :filter-option="filterOption"
        :total-order="totalOrder"
      />
    </div>
    <!--    </div>-->
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../../helpers/api/request";

import moment from "moment";
import DepositsTableSorted from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/DepositsPopup/DepositsTableSorted.component";
import DepositsStatsTables from "@/features/company.feature/sub_features.company/clients_table.sub_feature.company/components/DepositsPopup/DepositsStatsTables.component";

export default {
  name: "DepositsReportsPopup",
  components: { DepositsStatsTables, DepositsTableSorted },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  props: {
    dateFromCalendar: {
      type: String,
      required: true
    },
    timeout: {
      type: Boolean,
    }
  },
  data() {
    return {
      deposits: {},
      filterOption: "regular",
      lastComment: 0,
      reportBusy: false,
      report: [],
      stats: [],
      totalOrder: [],
      sortOrder: {
        0: "desc",
        1: "desc"
      },
      statsTabs: [
        {
          id: 0,
          name: "T",
          alias: "today"
        },
        {
          id: 1,
          name: "Y",
          alias: "yesterday"
        },
        {
          id: 2,
          name: "T-M",
          alias: "this_month"
        },
        {
          id: 3,
          name: "L-M",
          alias: "last_month"
        }
      ],
      selectedStatsTab: "today",
      secTabs: [
        {
          id: 1,
          name: "Regular",
          alias: "REGULAR"
        },
        {
          id: 0,
          name: "Stats",
          alias: "STATS"
        }
      ],
      selectedSecTab: "REGULAR",
      timeIcons: [
        "\uD83C\uDF05",
        "\uD83C\uDF1E",
        "\uD83C\uDF07",
        "\uD83C\uDF19"
      ]
    };
  },
  created() {
    this.getDepositsReport(this.dateFromCalendar)
  },

  methods: {
    reverseDate(date) {
      // Function gets date as string in format(YYYY-MM-DD) ade returns reverse date
      return date
        .split("-")
        .reverse()
        .join("-");
    },
    checkDeposits(deposits) {
      let flag = false;
      for (const key in deposits) {
        if (deposits[key].length > 0) {
          flag = true;
        }
      }
      return flag;
    },
    checkDayForWeekend(date) {
      return moment(date).weekday() === 0 || moment(date).weekday() === 6;
    },
    filterClientById(clientId) {
      this.$store.commit("clients/setFilterClientById", clientId);
    },
    async getDepositsReport(date) {
      try {
        const res = await apiClientCreator(
          `reports/deposits/shortcuts/popup`
        ).get("", {
          params: {
            date
          }
        });
        this.deposits = res.data.report[this.dateFromCalendar];

        this.report = res.data["report"][this.dateFromCalendar];
        this.stats = res.data["stats"][this.dateFromCalendar];
        this.totalOrder = res.data["id_with_total_number"];
      } catch (e) {}
    },
    changeFilter(event) {
      this.filterOption = event.target.value;
    },
    formatDate(date) {
      return moment(String(date)).format("DD/MM/YY");
    },
    formatTime(time) {
      return moment(String(time)).format("HH:mm");
    },
    checkTimeOfDay(time) {
      let format = "hh:mm:ss";

      let timeToCheck = moment(time, format);
      let midnight = moment("00:00:00", format),
        earlyMorning = moment("06:00:00", format),
        noon = moment("12:00:00", format),
        evening = moment("18:00:00", format),
        night = moment("23:59:59", format);
      if (timeToCheck.isBetween(midnight, earlyMorning, undefined, "[)"))
        return 3;
      if (timeToCheck.isBetween(earlyMorning, noon, undefined, "[)")) return 0;
      if (timeToCheck.isBetween(noon, evening, undefined, "[)")) return 1;
      if (timeToCheck.isBetween(evening, night, undefined, "[)")) return 2;
    },
    checkRegisterTime(time) {
      let format = "hh:mm:ss";

      let timeToCheck = moment(time, format);

      return !timeToCheck.isBetween(
        moment("08:00:00", format),
        moment("23:00:00", format),
        undefined,
        "()"
      );
    },
    showComment(id) {
      if (id !== this.lastComment && this.lastComment !== 0) {
        let lastPopUp = document.getElementById(this.lastComment);
        if (lastPopUp.classList.contains("show")) {
          lastPopUp.classList.toggle("show");
        }
      }
      let popup = document.getElementById(id);
      popup.classList.toggle("show");
      this.lastComment = id;
    },
    applySorting(typeSort, tableColumn, tableId) {
      let table,
        rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        switchcount = 0;
      table = document.getElementById(tableId);
      switching = true;
      this.sortOrder[typeSort] = "desc";
      while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 1; i < rows.length - 1; i++) {
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[tableColumn];
          y = rows[i + 1].getElementsByTagName("TD")[tableColumn];
          if (tableColumn === 15) {
            x = x.getElementsByClassName("numeric-diff")[0];
            y = y.getElementsByClassName("numeric-diff")[0];
          }
          if (this.sortOrder[typeSort] === "desc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) < Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          } else if (this.sortOrder[typeSort] === "asc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) > Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          }
        }
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else {
          if (switchcount === 0 && this.sortOrder[typeSort] === "desc") {
            this.sortOrder[typeSort] = "asc";
            switching = true;
          }
        }
      }
    },
    applyMailSorting(typeSort, tableColumn, tableId) {
      let table,
        rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        switchcount = 0;
      table = document.getElementById(tableId);
      switching = true;
      this.sortOrder[typeSort] = "desc";
      while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 1; i < rows.length - 1; i++) {
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[tableColumn];
          y = rows[i + 1].getElementsByTagName("TD")[tableColumn];
          if (this.sortOrder[typeSort] === "desc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) < Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          } else if (this.sortOrder[typeSort] === "asc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) > Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          }
        }
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else {
          if (switchcount === 0 && this.sortOrder[typeSort] === "desc") {
            this.sortOrder[typeSort] = "asc";
            switching = true;
          }
        }
      }
    },
    getTotalSum(amounts) {
      return Object.keys(amounts).reduce(
        (previous, key) => previous + amounts[key] * key,
        0
      );
    }
  }
};
</script>

<style scoped lang="scss">
table {
  width: 100%;
}
table,
th,
td {
  border-collapse: collapse;
  padding: 0.1em 0.2em;
  white-space: nowrap;
}
table,
th {
  direction: ltr;
  position: sticky;
  top: 0;
  background: white;
  vertical-align: initial;
  /*width: 45px;*/
}
table th {
  /*border-bottom: 1px solid #e5e4e4 ;*/
  margin-bottom: 10px;
}
tbody {
  border-top: 1px solid #e5e4e4;
}
tbody tr {
  height: 30px;
}
.chart-box {
  display: flex;
  background-color: white;
  flex-direction: column;
  direction: rtl;
}
.chart-box {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  background-color: white;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  border: 2px solid #a6a6a673;
  border-radius: 12px;
  padding-top: 12px;
  max-height: 369px;
  min-height: 200px;
  width: 1000px;
}
.main-tabs {
  max-width: 8%;
  max-height: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  position: relative;
  background: white;
  flex: 2;
}

.main-tabs.style2 li {
  max-height: 10%;
  border-radius: 5px 5px 0 0;
  transition: transform 0.1s ease;
}

.main-tabs li {
  max-width: 100%;
  min-width: 70px;
  font-size: 0.6vw;
  height: 18px;
  cursor: pointer;
  background: white;
  border-radius: 0;
  text-align: left;
  vertical-align: middle;
  line-height: 25px;
  border-bottom: 2px solid transparent;
  transition: background 0.2s ease, color 0.2s ease;
}

.main-tabs li:not(.empty):hover {
  transform: translateY(1px);
}

.main-tabs li.active {
  border-bottom: 1px solid #44a2d2 !important;
  color: #44a2d2;
}

.main-tabs.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.main-tabs.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.daily-stats-tabs {
  display: flex;
  justify-content: space-between;
  font-size: 0.7vw;
}
.report-rank {
  font-size: 0.6vw;
}
.negative {
  color: red;
}
.positive {
  color: green;
}
.time-title {
  font-weight: bold;
  padding: 1em 0 1em 0;
}
.deposits-data {
  display: flex;
}
.filter-buttons {
  font-size: 0.6vw;
}
.country-flag {
  margin-top: -3px;
  margin-left: -2px;
}

.popup {
  position: relative;
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.popup .popuptext {
  visibility: hidden;
  width: 400px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 0;
  position: absolute;
  z-index: 1;
  bottom: -180%;
  left: 50%;
  margin-left: -80px;
}

.popup .show {
  visibility: visible;
}
.btn-sm {
  padding: 0 1px 3px 0;
  font-size: 0.7vw;
  line-height: 1.5;
  border: none;
}
.btn-sm:active {
  border: none;
  outline: none;
  background: #e0e0e0;
}
.btn-sm:focus {
  border: none;
  outline: none;
}
.dep-report-tab {
  overflow-y: scroll;
  font-size: 0.61vw;
  display: flex;
  flex-direction: column;
  height: 200px;
  margin-left: 20px;
  min-width: 83%;
  border: 1px solid #e5e4e4;
  padding: 10px;
  border-radius: 10px;
}
.stats-initial-tables {
  display: flex;
  padding-bottom: 10px;
}
.table-divider {
  padding: 0 0.3em 0 0;
  margin-left: 8px;
}
.stat-segment-opener {
  padding: 10px 0;
}
.client_id_label:hover {
  cursor: pointer;
  background-color: #efefef;
}
.day_is_weekend {
  background-color: #f9a825;
}
.reg_hours {
  background-color: grey;
}

.tooltip-text {
  visibility: hidden;
  width: 15vw;
  font-size: 0.7vw;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
}

.tooltip-opener:hover .tooltip-text {
  visibility: visible;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
.style-nav.style2 li {
  /*border-radius: 5px 5px 0px 0px;*/
  transition: transform 0.1s ease;
}
.style-nav.style2 li:not(:last-child) {
  margin-right: 2px;
}

.style-nav li {
  max-width: 100%;
  min-width: 72px;
  height: 30px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 30px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.2s ease, color 0.2s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(4px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
  /* transform: translateY(4px);*/
}

.style-nav.style1 li:not(.empty):hover {
  background: #44a2d2;
  color: white;
}

.style-nav.style1 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
}
.report-box {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
}
.stats-box {
  display: flex;
  flex-direction: column;
}
.diff-tr {
  display: flex;
  flex-direction: column-reverse;
}
.diff-wrapper {
  display: flex;
}
.numeric-diff {
  display: none;
}
.reg-bg > span {
  background-color: #008b00;
  color: #fff;
}
.dep-bg > span {
  background-color: #c12fff;
  color: #fff;
}
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
::-webkit-scrollbar-thumb {
  background: #c12fff;
  border-radius: 12px;
}
::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(13deg, #ffc7fc 14%, #f9d4ff 64%);
}
::-webkit-scrollbar-track {
  background: #ffffff;
  border-radius: 10px;
  box-shadow: inset 7px 10px 12px #f0f0f0;
}
.report-calendar .mx-table-date td,
.mx-table-date th {
  height: 5px !important;
  font-size: 9px !important;
}
.main-graph-window {
  width: 100%;
  min-height: 200px;
  background-color: #fff;
  /*padding-top: 5px;*/
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  overflow: hidden;
}

.dropdown-item {
  height: 35px;
  min-height: 8%;
  /*padding: 1px 0px;*/
  /*margin: 0px;*/
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
  /*border-radius: 5px 0px 0px 5px;*/
  border-radius: 0px 5px 5px 0px;
  //margin-bottom: 1px;
  background-color: white;
  border: 1px solid #e5e4e4;
  position: relative;
  z-index: 1;
}
.dropdown-item:focus {
  outline: none;
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}
.dropdown-item.cal-match {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}

.dropdown-toggle .toggle-left-side {
  /*margin-right: 10px;*/
  margin-right: 36px;
}

.tab-flex-wrapper {
  /*flex: 0.5;*/
  display: flex;
  flex-direction: column;
  width: 150px;
}
.tab-item {
  border: 1px solid #e5e4e4;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 4px;
  animation: all 0.3s ease infinite;
  text-transform: uppercase;
}

.tab-item:hover {
  transform: translateX(5px);
}
.tab-item.active {
  background: #ae3ede;
  color: white;
}
/*input[type="radio"] {*/
/* remove standard background appearance */
/*-webkit-appearance: none;*/
/*-moz-appearance: none;*/
/*appearance: none;*/
/* create custom radiobutton appearance */
/*display: inline-block;*/
/*width: 25px;*/
/*height: 25px;*/
/*padding: 6px;*/
/*!* background-color only for content *!*/
/*background-clip: content-box;*/
/*border: 2px solid #bbbbbb;*/
/*background-color: #e7e6e7;*/
/*border-radius: 50%;*/
/*}*/

/************         new style ********************************************************************************************************************************************************************************/
.main-popup-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.left-container {
  flex: 1;
  max-width: 150px;
  /*border: 1px solid;*/
}
.right-container {
  flex: 4;
  /*border: 1px solid;*/
}
.list-item-animate {
  font-weight: 700;
  margin-top: 10px;
  transition: all 0.3s ease;
  border-radius: 0px 5px 5px 0px;
}
.list-item-animate:hover {
  transform: translateX(8px);
}
.list-item-animate.active {
  background-color: #ae3ede;
  border-color: #ae3ede;
  color: white;
}
.title-wrapper {
  display: flex;
}
.title-date {
  flex: 1;
}
.filter-options-wrapper {
  flex: 3;
}

/***** CSS of custom radio btn STARTS ****/
@keyframes click-wave {
  0% {
    height: 25px;
    width: 25px;
    opacity: 0.35;
    position: relative;
  }
  100% {
    height: 40px;
    width: 40px;
    margin-left: -8px;
    margin-top: -10px;
    opacity: 0;
  }
}

.option-input {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  /*top: 13.33333px;*/
  top: 8px;
  right: 0;
  bottom: 0;
  left: 0;
  height: 25px;
  width: 25px;
  transition: all 0.15s ease-out 0s;
  background: #cbd1d8;
  border: none;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  margin-right: 0.5rem;
  outline: none;
  position: relative;
  z-index: 1000;
}
.option-input:hover {
  background: #9faab7;
  outline: none;
}
.option-input:checked {
  background: #ae3ede;
  outline: none;
}
.option-input:checked::before {
  height: 25px;
  width: 25px;
  position: absolute;
  content: "✔";
  display: inline-block;
  font-size: 20px;
  text-align: center;
  line-height: 25px;
  outline: none;
}
.option-input:checked::after {
  -webkit-animation: click-wave 0.65s;
  -moz-animation: click-wave 0.65s;
  animation: click-wave 0.65s;
  background: #ae3ede;
  content: "";
  display: block;
  position: relative;
  z-index: 100;
  outline: none;
}
.option-input.radio {
  border-radius: 50%;
}
.option-input.radio::after {
  border-radius: 50%;
}

/***** CSS of custom radio btn ENDS ****/

.filter-options-label {
  font-weight: 700;
  margin-right: 10px;
  cursor: pointer;
}
.filter-options-label:hover {
  opacity: 0.8;
}
.title-date {
  padding-top: 15px;
  /*padding-left: 20px;*/
}
.title-date-class {
  margin-left: 40px;
  font-weight: 600;
  font-size: 15px;
  background-color: #ae3ede;
  color: white;
  padding: 3px 7px;
  border-radius: 5px;
}
.dep-table-wrapper {
  //margin: 1vh 0;
  height: 31vh;
}
</style>
